import { buildUrl } from 'domain/Api';
import { createApiActionCreator, ApiCall } from 'omni-common-ui';

const ACTION_OBJECT_NAME = 'GRAMMA_PRO';

export const FETCH_GRAMMA_PRO_REQUEST = `FETCH_${ACTION_OBJECT_NAME}_REQUEST`;
export const FETCH_GRAMMA_PRO_SUCCESS = `FETCH_${ACTION_OBJECT_NAME}_SUCCESS`;
export const FETCH_GRAMMA_PRO_FAILURE = `FETCH_${ACTION_OBJECT_NAME}_FAILURE`;


const DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

const buildGrammaProURL = (groupId) =>
  buildUrl(`/groups/${groupId}/grammar-pro-reports`);

const createfetchGrammaProActions = (groupId) =>
  createApiActionCreator(
    ACTION_OBJECT_NAME,
    buildGrammaProURL(groupId),
    'GET',
    DISABLE_DEFAULT_ACTION_EXTRAS,
    { groupId },
    DISABLE_DEFAULT_ACTION_EXTRAS
  );

export const fetchGrammaPro = (groupId) =>
  createfetchGrammaProActions(groupId);


export function fetchGrammaProIfNeed(activityId, studentId) {
  const method = 'GET';
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state,
      { method, url: fetchGrammaPro(activityId, studentId) })) {
      return false;
    }
    return dispatch(fetchGrammaPro(activityId, studentId));
  };
}



// WEBPACK FOOTER //
// ./data/GrammaPro/actions.js